/**
 * 顶部弹窗车型匹配组件
 * */

//公共ajax封装，获取token封装
function myAjax(options){
    options = options || {};
    // 接口基础路径
    // const baseUrl = 'https://uat-smartoperation-api.oedro.com/';
    const baseUrl = 'https://smartoperation-api.oedro.com/'; 
    const getToken = () => {
        return new Promise((resolve, reject) => {
            jQuery.ajax({
                url: baseUrl + 'api/shopify/auth',
                type:'post',
                success: (res) => {
                    if(res.status === 'success'){
                        sessionStorage.setItem('php-tools-token', res.data.token)
                        resolve();
                    }else{
                        reject();
                    }
                },
                error: e=> {
                    console.log('e:',e)
                    reject();
                }
            })
        });
    };

    return new Promise((resolve, reject) => {
        if(!sessionStorage.getItem('php-tools-token')){
            getToken().then(() => {
                myAjax(options).then((data) => {
                    resolve(data);
                }).catch(e => {
                    reject();
                })
            });
        }else{
            jQuery.ajax({
                url: baseUrl + options.url,
                headers:{
                    'Authorization': 'Bearer ' + sessionStorage.getItem('php-tools-token'),
                    'Access-Control-Allow-Origin':'*'
                },
                data: options.data,
                dataType: 'json',
                success:function (data){
                    if(Number(data.code) === 401){
                        getToken().then(() => {
                            myAjax(options).then((data) => {
                                resolve(data);
                            }).catch(e => {
                                reject();
                            })
                        });
                    }else{
                        resolve(data);
                    }
                },
                error:function (e){
                    reject(e)
                }
            })
        }

    });
}

//用vue的方式生成详情页的车型匹配功能
function InitSelectVehicleForProductDetail(options){
    if(!document.querySelector('#vehicletype_area')){
        return;
    }
    document.querySelector('#vehicletype_area').innerHTML = `
    <div class="vehicletype_search-form-wrapper" v-show="searchMatch">
         <div>
            <select id="select-your-vehicle-year" @change="changeYear" v-model="currentYear">
                <option v-for="(item,i) in yearList" :key="i" :value="item.value">{{item.label}}</option>
            </select>     
        </div>
        <div v-show="currentYear !== '0'">
            <select id='select-your-vehicle-make' @change="changeMake" v-model="currentMake">
                <option v-for="(item,i) in makeList" :key="i" :value="item.value">{{item.label}}</option>
            </select>     
        </div>
        <div v-show="currentMake !== '0'">
            <select id='select-your-vehicle-model' @change="changeModel" v-model="currentModel">
                <option v-for="(item,i) in modelList" :key="i" :value="item.value">{{item.label}}</option>
            </select>     
        </div>
        <div v-show="currentModel !== '0'">
            <select id='select-your-vehicle-trim' @change="changeTrim" v-model="currentTrim">
                <option v-for="(item,i) in trimList" :key="i" :value="item.value">{{item.label}}</option>
            </select>     
        </div>
        <div class="vehicletype_area_btns" v-if="currentYear !== '0' && currentMake !== '0' && currentModel !== '0' && currentTrim !== '0'">
            <div class="button-action">
                <input v-if="!isDetailsPage" type="button" name="submit" value="Search" class="btn ymm_search" :disabled="!isAllowSubmit" @click="handlerSubmit">
                <input type="button" name="reset" value="Change Vehicle" class="btn btn--secondary" @click="resetForm">
            </div> 
        </div>
    </div>
   
    <div class="vehicletype_search_result-wrapper" v-if="completeSearch">
       <span style='color:green;' v-if="searchMatch&&isAllowSubmit">FITS YOUR VEHICLE: {{currentYear}} {{currentMake}} {{currentModel}}</span>
       <div class="search-not-match" v-if="!searchMatch">
            <div class="search-ont-match-text">
                <p><strong>Vehicle:</strong> {{currentYear}} {{currentMake}}  {{currentModel}}</p>
                <p v-if="searchCategory">
                This item is not suitable for your vehicle. However, we have other {{searchCategory}} that are suitable for your vehicle.  <br>
                Or you can choose other suitable car accessories.
                </p>
                <p v-if="!searchCategory">
                    This item is not suitable for your vehicle. However, we have other suitable car accessories that are available to purchase.
                </p>
            </div>
            <div class="search-ont-match-btns">
                <button v-if="searchCategory" :data-searchCategory="searchCategory" @click="goToCurrentCategorySearch">Shop the {{searchCategory}}</button>
                <button @click="goToAllCategorySearch" :data-url="searchResultUrl">Shop other Accessories</button>
                <button @click="changeVehicle"  v-if="!searchCategory">Change vehicle</button>
            </div>
        </div>   
           
    </div>
`

    const { createApp } = Vue

    window.YmmSearchboxVueApp = createApp({
        data(){
            return {
                //是否是详情页
                isDetailsPage:options.fromDetailPage,
                currentYear:'0',
                yearList:[{value:'0', label:'Select Year'}],
                currentMake:'0',
                makeList:[{value:'0', label:'Select Make'}],
                currentModel:'0',
                modelList:[{value:'0', label:'Select Model'}],
                currentTrim:'0',
                trimList:[{value:'0', label:'Select Trim'}],
                completeSearch:false, //是否完成搜索
                searchMatch: true, //是否搜索匹配中
                searchCategory:'', //商品所在分类是否有其他商品能够匹配筛选车型，存在值为分类名称，不存在值为 null
                searchResultUrl:'', //搜素url
            }
        },
        computed:{
            isAllowSubmit(){
                return this.currentYear !== '0' && this.currentMake !== '0' && this.currentModel !== '0' && this.currentTrim !== '0';
            }
        },
        mounted() {
            if(options.fromDetailPage){
                this.pageInit();
                // jQuery('#AddToCart-product-template').attr('disabled', true);
            }else{
                this.pageInit();
                jQuery('#product-actions-' + options.productId).find('.add-to-cart-btn').attr('disabled', true);
                jQuery('#product-actions-' + options.productId).find('.before-add-to-cart-note').show();
            }
        },
        methods:{
            // 是否填充值
            pageInit(){
                if(options.fromDetailPage) {
                    //详情页 - 如果有缓存才去match
                    if(this.getCache('year')&& this.getCache('make')&&this.getCache('model') && this.getCache('trim')){
                    // 如果是详情页-需要再进行match
                    const mathcParams =  {
                        product_id: options.productId + '~', 
                        year:this.getCache('year'),
                        make:this.getCache('make'),
                        model:this.getCache('model'),
                        trim:this.getCache('trim'),
                    };
                    myAjax({
                        url: 'api/shopify/vehicle/match',
                        data: mathcParams
                    }).then(res => {
                        console.log('vue-match-res-data:', res)
                        if(res.code === 200){
                           let searchMatch = !!(res.data || {}).match
                            //如果搜素匹配中了就解除加购按钮的禁用状态
                            if(searchMatch){
                                this.autoFillValue();
                                jQuery('#AddToCart-product-template').attr('disabled', false);
                                this.searchMatch=true;
                                this.completeSearch=true;
                                if((res.data || {}).category){
                                    this.searchCategory = res.data.category;
                                }
                            }else {
                              // 没有匹配中-说明不是从搜索结果点击
                               this.getYearAjaxData();
                            }
                        }
                        this.hideLoading();
                    })
                }else {
                    // 没有缓存-不用match
                    this.getYearAjaxData();
                }
                }else {
                    this.autoFillValue();
                }
            },
            //自动填充值
            autoFillValue(){
                if(this.getCache('year')&& this.getCache('make')&&this.getCache('model') && this.getCache('trim')){
                    this.showLoading();
                    this.getYearAjaxData(() => {
                        this.currentYear = this.getCache('year');
                    }, true)  
                    this.getMakeAjaxData({year: this.getCache('year')}, () => {
                        this.currentMake = this.getCache('make');
                    }, true)
                    this.getModelAjaxData({year: this.getCache('year'), make: this.getCache('make')}, () => {
                        this.currentModel = this.getCache('model');
                    }, true)
                    this.getTrimAjaxData({year: this.getCache('year'), make: this.getCache('make'), model:this.getCache('model')}, () => {
                        this.currentTrim = this.getCache('trim');
                    }, true)
                }                
            },
            //重置
            resetForm(){
                this.currentYear = '0';
                this.currentMake = '0';
                this.makeList = [{value:'0', label:'Select Make'}];
                this.currentModel = '0';
                this.modelList = [{value:'0', label:'Select Model'}];
                this.currentTrim = '0';
                this.trimList = [{value:'0', label:'Select Trim'}];
                this.completeSearch = false;
                this.searchCategory = '';
                this.searchMatch = true;

                if(options.fromDetailPage){
                    jQuery('#AddToCart-product-template').attr('disabled', true);
                }else{
                    jQuery('#product-actions-' + options.productId).find('.add-to-cart-btn').attr('disabled', true);
                }
            },
            //提交
            handlerSubmit(){
                var url = '';
                var joinStr = '~'; //每个下拉框之间的连接符
                var selectJoinStr = '-'; //下拉框内参数连接符
                var isAllSelectValueFilled = true; //是否所有下拉框填充满了
                if(this.currentYear !== '0'){
                    this.setCache({year: this.currentYear})
                    url += 'yr_' + this.currentYear
                }else{
                    this.setCache({year: '0'})
                    isAllSelectValueFilled = false;
                }

                if(this.currentMake !== '0'){
                    this.setCache({make: this.currentMake})
                    url += joinStr + 'mk_' + this.currentMake.replace(/\s|\./g, selectJoinStr)
                }else{
                    this.setCache({make: '0'})
                    isAllSelectValueFilled = false;
                }

                if(this.currentModel !== '0'){
                    this.setCache({model: this.currentModel})
                    url += joinStr + 'md_' + this.currentModel.replace(/\s|\./g, selectJoinStr)
                }else{
                    this.setCache({model: '0'})
                    isAllSelectValueFilled = false;
                }

                if(this.currentTrim !== '0'){
                    this.setCache({trim: this.currentTrim})
                    url += joinStr + 'kj_' + this.currentTrim.replace(/\s|\./g, selectJoinStr)
                }else{
                    this.setCache({trim: '0'})
                    isAllSelectValueFilled = false;
                }
                this.searchResultUrl = '/pages/product-result?rq=' + url.toLowerCase();

                if(!isAllSelectValueFilled){
                    return;
                }
                
                var addCartButton = document.querySelector('#AddToCart-product-template')
                if(addCartButton){
                    addCartButton.classList.add('is-loading-select')
                }
              
                myAjax({
                    url: 'api/shopify/vehicle/match',
                    data: {
                        product_id: options.productId + '~', //服务端渲染的id
                        year: this.currentYear,
                        make: this.currentMake,
                        model: this.currentModel,
                        trim: this.currentTrim,
                    }
                }).then(res => {
                    console.log('vue-res-data:', res)
                    if(res.code === 200){
                        this.searchMatch = !!(res.data || {}).match
                        //如果搜素匹配中了就解除加购按钮的禁用状态
                        if(this.searchMatch){
                            if(options.fromDetailPage){
                                jQuery('#AddToCart-product-template').attr('disabled', false);
                            }else{
                                jQuery('#product-actions-' + options.productId).find('.add-to-cart-btn').attr('disabled', false);
                            }
                        }
                        if((res.data || {}).category){
                            this.searchCategory = res.data.category;
                        }
                    }

                    if(addCartButton){
                        addCartButton.classList.remove('is-loading-select')
                    }
                  
                    this.completeSearch = true;
                })
            },

            //跳转全局搜索
            goToAllCategorySearch(){
                if(this.searchResultUrl){
                    location.href = this.searchResultUrl;
                }
            },

            //重新搜索
            changeVehicle(){
                this.resetForm();
            },

            //跳转搜索带分类
            goToCurrentCategorySearch(){
                if(this.searchResultUrl && this.searchCategory){
                    location.href = this.searchResultUrl + '~sm_' + this.searchCategory.replace(/\s|\./g, '-').toLowerCase();
                }
            },

            getCache(key){
                var selectionCacheStr = localStorage.getItem('SelectForShopByVehicleCache');
                var selectionCache = {};
                if(/^{.*}$/.test(selectionCacheStr)){
                    selectionCache = JSON.parse(selectionCacheStr);
                }
                return selectionCache[key] && selectionCache[key] != '0'? selectionCache[key]: ''
            },

            setCache(options){
                var selectionCacheStr = localStorage.getItem('SelectForShopByVehicleCache');
                var selectionCache = {};
                if(/^{.*}$/.test(selectionCacheStr)){
                    selectionCache = JSON.parse(selectionCacheStr);
                }
                if(options.year){
                    selectionCache.year = options.year;
                }
                if(options.make){
                    selectionCache.make = options.make;
                }
                if(options.model){
                    selectionCache.model = options.model;
                }
                if(options.trim){
                    selectionCache.trim = options.trim;
                }
               

                localStorage.setItem('SelectForShopByVehicleCache', JSON.stringify(selectionCache));
            },
            changeYear(){
                this.currentMake = '0';
                this.makeList = [{value:'0', label:'Select Make'}];
                this.currentModel = '0';
                this.modelList = [{value:'0', label:'Select Model'}];
                this.currentTrim = '0';
                this.trimList = [{value:'0', label:'Select Trim'}];
                this.getMakeAjaxData({year: this.currentYear})
                this.completeSearch = false;
            },
            changeMake(){
                this.currentModel = '0';
                this.modelList = [{value:'0', label:'Select Model'}];
                this.currentTrim = '0';
                this.trimList = [{value:'0', label:'Select Trim'}];
                this.getModelAjaxData({year: this.currentYear, make: this.currentMake})
                this.completeSearch = false;
            },
            changeModel(){
                this.currentTrim = '0';
                this.trimList = [{value:'0', label:'Select Trim'}];
                this.getTrimAjaxData({year: this.currentYear, make: this.currentMake, model: this.currentModel})
                this.completeSearch = false;
            },
            changeTrim(){
                this.completeSearch = false;
                 //如果是详情页-直接到搜索引擎之后就确认
                 if(options.fromDetailPage){
                    this.handlerSubmit();
                }
            },
            //接口参数处理
            getParamsData(params){
                if(options.fromDetailPage){
                    return Object.assign({}, params,{product_id:`${options.productId}~`})
                }else{
                    return params
                }
            },
            //获取年份数据接口
            getYearAjaxData(callback, isNotShowLoading){
                var t = this;
                !isNotShowLoading && t.showSelectLoading(0);
                var params = this.getParamsData({
                    key:'year'
                });
                myAjax({
                    url: 'api/shopify/vehicle/options',
                    data: params
                }).then(data => {
                    console.log('vue-year-data:', data)
                    if(Array.isArray(data.data)){
                        t.yearList = [{value:'0', label:'Select Year'}, ...data.data.map(item => ({value: item, label: item}))]
                    }
                    !isNotShowLoading && t.hideSelectLoading(0)
                    typeof callback === 'function' && callback()
                })
            },

            getMakeAjaxData(opts, callback, isNotShowLoading){
                var t = this;
                !isNotShowLoading && t.showSelectLoading(1);
                var params = this.getParamsData({
                    key:'make',
                    year: opts.year
                });
                myAjax({
                    url: 'api/shopify/vehicle/options',
                    data: params
                }).then(data => {
                    console.log('vue-make-data:', data)
                    if(Array.isArray(data.data)){
                        t.makeList = [{value:'0', label:'Select Make'}, ...data.data.map(item => ({value: item, label: item}))]
                    }
                    !isNotShowLoading && t.hideSelectLoading(1)
                    typeof callback === 'function' && callback()
                })
            },

            getModelAjaxData(opts, callback, isNotShowLoading){
                var t = this;
                !isNotShowLoading && t.showSelectLoading(2);
                var params = this.getParamsData({
                    key: 'model',
                    year: opts.year,
                    make: opts.make
                });
                myAjax({
                    url: 'api/shopify/vehicle/options',
                    data: params
                }).then(data => {
                    console.log('vue-model-data:', data)
                    if (Array.isArray(data.data)) {
                        t.modelList = [{value: '0', label: 'Select Model'}, ...data.data.map(item => ({
                            value: item,
                            label: item
                        }))]
                    }
                    !isNotShowLoading && t.hideSelectLoading(2)
                    typeof callback === 'function' && callback()
                })
            },

            getTrimAjaxData(opts,callback, isNotShowLoading){
                var t = this;
                !isNotShowLoading && t.showSelectLoading(3);
                var params = this.getParamsData({
                    key: 'trim',
                    year: opts.year,
                    make: opts.make,
                    model: opts.model
                });
                myAjax({
                    url: 'api/shopify/vehicle/options',
                    data: params
                }).then(data => {
                    console.log('vue-trim-data:', data)
                    if (Array.isArray(data.data)) {
                        t.trimList = [{value: '0', label: 'Select Trim'}, ...data.data.map(item => ({
                            value: item,
                            label: item
                        }))]
                    }
                    !isNotShowLoading && t.hideSelectLoading(3)
                    typeof callback === 'function' && callback()
                })
            },
            showLoading(){
                if(document.querySelector('.component-full-loading')){
                    return;
                }
                var ele = document.createElement('div');
                ele.className = 'component-full-loading';
                ele.innerHTML = `
            <div class="loading-wrapper" style="position: fixed;top: 0;left: 0;width: 100%;height: 100%;background: #0000004f;z-index:999999999;">
                 <div class="inner-loading" style="background: #494949;border: 1px solid #ccc; color: #fff; text-align: center; position: absolute;left:50%; top:50%; transform: translate(-50%, -50%);line-height: 38px;width: 150px;border-radius: 5px;">
                    <img style="vertical-align: middle;margin-right: 10px;" src="data:image/gif;base64,R0lGODlhEAAQALMMAKqooJGOhp2bk7e1rZ2bkre1rJCPhqqon8PBudDOxXd1bISCef///wAAAAAAAAAAACH/C05FVFNDQVBFMi4wAwEAAAAh+QQFAAAMACwAAAAAEAAQAAAET5DJyYyhmAZ7sxQEs1nMsmACGJKmSaVEOLXnK1PuBADepCiMg/DQ+/2GRI8RKOxJfpTCIJNIYArS6aRajWYZCASDa41Ow+Fx2YMWOyfpTAQAIfkEBQAADAAsAAAAABAAEAAABE6QyckEoZgKe7MEQMUxhoEd6FFdQWlOqTq15SlT9VQM3rQsjMKO5/n9hANixgjc9SQ/CgKRUSgw0ynFapVmGYkEg3v1gsPibg8tfk7CnggAIfkEBQAADAAsAAAAABAAEAAABE2QycnOoZjaA/IsRWV1goCBoMiUJTW8A0XMBPZmM4Ug3hQEjN2uZygahDyP0RBMEpmTRCKzWGCkUkq1SsFOFQrG1tr9gsPc3jnco4A9EQAh+QQFAAAMACwAAAAAEAAQAAAETpDJyUqhmFqbJ0LMIA7McWDfF5LmAVApOLUvLFMmlSTdJAiM3a73+wl5HYKSEET2lBSFIhMIYKRSimFriGIZiwWD2/WCw+Jt7xxeU9qZCAAh+QQFAAAMACwAAAAAEAAQAAAETZDJyRCimFqbZ0rVxgwF9n3hSJbeSQ2rCWIkpSjddBzMfee7nQ/XCfJ+OQYAQFksMgQBxumkEKLSCfVpMDCugqyW2w18xZmuwZycdDsRACH5BAUAAAwALAAAAAAQABAAAARNkMnJUqKYWpunUtXGIAj2feFIlt5JrWybkdSydNNQMLaND7pC79YBFnY+HENHMRgyhwPGaQhQotGm00oQMLBSLYPQ9QIASrLAq5x0OxEAIfkEBQAADAAsAAAAABAAEAAABE2QycmUopham+da1cYkCfZ94UiW3kmtbJuRlGF0E4Iwto3rut6tA9wFAjiJjkIgZAYDTLNJgUIpgqyAcTgwCuACJssAdL3gpLmbpLAzEQA7" alt="loading">
                    <span style="vertical-align: middle;">loading...</span>
                </div>
            </div>
        `
                document.body.appendChild(ele);
            },

            hideLoading (){
                var ele = document.querySelector('.component-full-loading')
                ele && document.body.removeChild(ele);
            },

            showSelectLoading(nth){
                var ymm = document.querySelector('.vehicletype_search-form-wrapper');
                var li = ymm?.querySelectorAll('div')[nth];
                if(li){
                    li.classList.add('is-loading-select')
                }
            },
            hideSelectLoading(nth){
                var ymm = document.querySelector('.vehicletype_search-form-wrapper');
                var li = ymm?.querySelectorAll('div')[nth];
                if(li){
                    li.classList.remove('is-loading-select')
                }
            }

        }
    }).mount('#vehicletype_area')
}

//生成M端首页的车型匹配功能
//主逻辑开始
$(function(){
    class SelectForShopByVehicle{
        constructor(options = {}) {
            this.options = options;
            this.doLayout();
            // if(this.getCache('year')){
            //     jQuery('.shop-your-vehicle-checked').show();
            // }
        }

        doLayout(){
            var $wrapper = jQuery(`
            <div class="SelectForShopByVehicleName-drop-list">
              <div class="search-drop-list-head">
                Manage Your Vehicle
              </div>
              <ul class="search-drop-list-select-list">
                <li class="drop-list-item">
                  <select name="select-for-shop-by-vehicle-select-year">
                    <option value="0">Select Year</option>
                  </select>
                </li>
                <li class="drop-list-item">
                  <select name="select-for-shop-by-vehicle-select-make">
                    <option value="0">Select Make</option>
                  </select>
                </li>
                <li class="drop-list-item">
                  <select name="select-for-shop-by-vehicle-select-model">
                    <option value="0">Select Model</option>
                  </select>
                </li>
                <li class="drop-list-item">
                  <select name="select-for-shop-by-vehicle-select-trim">
                    <option value="0">Select Trim</option>
                  </select>
                </li>
              </ul>
              <div class="search-drop-search-btn">
                <button class="select-for-shop-by-vehicle-search">Search</button>
                <button class="select-for-shop-by-vehicle-reset">Reset</button>
              </div>
            </div>
        `)

            if($('.SelectForShopByVehicleName-drop-list').length){
                if($('.SelectForShopByVehicleName-drop-list').is(':hidden')){
                    $('.SelectForShopByVehicleName-drop-list').show();
                }else{
                    $('.SelectForShopByVehicleName-drop-list').hide()
                }
            }else{
                jQuery('body').append($wrapper);
                this.handlerCloseClick()
                this.handlerEvent()
                this.handlerSubmitEvent()
                this.autoFillDataByCache()
                this.bindResetFunc()
            }

            $('.SelectForShopByVehicleName-drop-list').css({top:this.options.target.offset().top + this.options.target.height() + 'px'});
            if($(window).width() > 760){
                $('.SelectForShopByVehicleName-drop-list').css({left:(this.options.target.offset().left + 20 - $('.SelectForShopByVehicleName-drop-list').width()/2) + 'px'});
            }else{
                //如果是手机端
                $('.SelectForShopByVehicleName-drop-list').css({top:this.options.target.offset().top + this.options.target.height() + 'px', left:'0', width:'100%'});
            }
        }

        //重置方法绑定
        bindResetFunc(){
            jQuery('.select-for-shop-by-vehicle-reset').on('click', function (){
                jQuery('select[name="select-for-shop-by-vehicle-select-year"]').val('0')
                jQuery('select[name="select-for-shop-by-vehicle-select-make"]').val('0')
                jQuery('select[name="select-for-shop-by-vehicle-select-model"]').val('0')
                jQuery('select[name="select-for-shop-by-vehicle-select-trim"]').val('0')

                localStorage.removeItem('SelectForShopByVehicleCache'); //重置就去掉缓存
                jQuery('.shop-your-vehicle-checked').hide();
            })
        }

        //自动填充缓存下拉项
        autoFillDataByCache(){
            const p0 =  new Promise((resolve, reject) => {
                this.getYearAjaxData(() => {
                    if(this.getCache('year')){
                        jQuery('select[name="select-for-shop-by-vehicle-select-year"]').val(this.getCache('year'))
                    }
                    resolve();
                }, true);
            })

            const p1 = new Promise((resolve, reject) => {
                if(this.getCache('year') && this.getCache('make')){
                    this.getMakeAjaxData({year: this.getCache('year')}, () => {
                        jQuery('select[name="select-for-shop-by-vehicle-select-make"]').val(this.getCache('make'))
                        resolve();
                    }, true)
                }else{
                    resolve();
                }
            })

            const p2 = new Promise((resolve, reject) => {
                if(this.getCache('make') && this.getCache('model')){
                    this.getModelAjaxData({year: this.getCache('year'), make: this.getCache('make')}, () => {
                        jQuery('select[name="select-for-shop-by-vehicle-select-model"]').val(this.getCache('model'))
                        resolve();
                    }, true)
                }else{
                    resolve();
                }
            })

            const p3 = new Promise((resolve, reject) => {
                if(this.getCache('model') && this.getCache('trim')){
                    this.getTrimAjaxData({year: this.getCache('year'), make: this.getCache('make') ,model:this.getCache('model')}, () => {
                        jQuery('select[name="select-for-shop-by-vehicle-select-trim"]').val(this.getCache('trim'))
                        resolve();
                    }, true)
                }else{
                    resolve();
                }
            });
            this.showSelectLoading(0);
            Promise.all([p0, p1,p2,p3]).then(() => {
                this.hideSelectLoading(0);
                //如果没有全部选择就禁用搜索按钮
                if(jQuery('select[name="select-for-shop-by-vehicle-select-model"]').val() !== '0'){
                    jQuery('.select-for-shop-by-vehicle-search').attr("disabled", false);
                }else{
                    jQuery('.select-for-shop-by-vehicle-search').attr("disabled", true);
                }
            })

        }

        renderYearData(){
            if(Array.isArray(this.yearList) && this.yearList.length){
                jQuery('select[name="select-for-shop-by-vehicle-select-year"]').html(this.yearList.map(item => ('<option value="'+item.value+'">'+item.label+'</option>')).join(''))
            }else{
                jQuery('select[name="select-for-shop-by-vehicle-select-year"]').html('<option value="0">Select Year</option>')
            }
        }

        renderMakeData(){
            if(Array.isArray(this.makeList) && this.makeList.length){
                jQuery('select[name="select-for-shop-by-vehicle-select-make"]').html(this.makeList.map(item => ('<option value="'+item.value+'">'+item.label+'</option>')).join(''))
            }else{
                jQuery('select[name="select-for-shop-by-vehicle-select-make"]').html('<option value="0">Select Make</option>');
            }
        }

        renderModelData(){
            if(Array.isArray(this.modelList) && this.modelList.length){
                jQuery('select[name="select-for-shop-by-vehicle-select-model"]').html(this.modelList.map(item => ('<option value="'+item.value+'">'+item.label+'</option>')).join(''))
            }else{
                jQuery('select[name="select-for-shop-by-vehicle-select-model"]').html('<option value="0">Select Model</option>');
            }
        }

        renderTrimData(){
            if(Array.isArray(this.trimList) && this.trimList.length){
                jQuery('select[name="select-for-shop-by-vehicle-select-trim"]').html(this.trimList.map(item => ('<option value="'+item.value+'">'+item.label+'</option>')).join(''))
            }else{
                jQuery('select[name="select-for-shop-by-vehicle-select-trim"]').html('<option value="0">Select Trim</option>');
            }
        }

        getYearAjaxData(callback, isNotShowLoading){
            var t = this;
            !isNotShowLoading && t.showSelectLoading(0)
            myAjax({
                url: 'api/shopify/vehicle/options',
                data: {
                    key:'year'
                }
            }).then(data => {
                console.log('year-data:', data)
                if(Array.isArray(data.data)){
                    t.yearList = [{value:'0', label:'Select Year'}, ...data.data.map(item => ({value: item, label: item}))]
                }
                t.renderYearData();
                !isNotShowLoading && t.hideSelectLoading(0)
                typeof callback === 'function' && callback()
            })

        }

        getMakeAjaxData(opts, callback, isNotShowLoading){
            var t = this;
            !isNotShowLoading && t.showSelectLoading(1)
            myAjax({
                url: 'api/shopify/vehicle/options',
                data: {
                    key:'make',
                    year: opts.year
                }
            }).then(data => {
                console.log('make-data:', data)
                if(Array.isArray(data.data)){
                    let allCars=["Chevrolet","GMC","Ford","Dodge","Ram","Toyota","Nissan","Jeep","Honda","Cadillac","Pontiac","Chrysler","Buick","Lincoln","BMW","Hyundai","Isuzu","Mazda","Infiniti","Tesla","Kia","Lexus","Subaru","Mercedes-Benz","Oldsmobile","Saturn","Acura","SAAB","Suzuki","Mercury","Volkswagen","Freightliner","Mitsubishi","Plymouth","Peterbilt","Savana","Scion","Sienna","Hummer","Volvo","Kenworth"];
                    let res = data.data;
                    let finArr=[];
                    let first = allCars.filter(x=>res.indexOf(x)!=-1);
                    finArr=[].concat(first);
                    if(first.length<res.length){
                        finArr=finArr.concat(res.filter(x=>first.indexOf(x)===-1));
                    }
                    t.makeList = [{value:'0', label:'Select Make'}, ...finArr.map(item => ({value: item, label: item}))]
                }
                t.renderMakeData();
                !isNotShowLoading && t.hideSelectLoading(1)
                typeof callback === 'function' && callback()
            })
        }

        getModelAjaxData(opts, callback, isNotShowLoading){
            var t = this;
            !isNotShowLoading && t.showSelectLoading(2)
            myAjax({
                url: 'api/shopify/vehicle/options',
                data: {
                    key:'model',
                    year: opts.year,
                    make: opts.make
                }
            }).then(data => {
                console.log('model-data:', data)
                if(Array.isArray(data.data)){
                    t.modelList = [{value:'0', label:'Select Model'}, ...data.data.map(item => ({value: item, label: item}))]
                }
                t.renderModelData();
                !isNotShowLoading && t.hideSelectLoading(2)
                typeof callback === 'function' && callback()
            })
        }

        getTrimAjaxData(opts,callback, isNotShowLoading){
            var t = this;
            !isNotShowLoading && t.showSelectLoading(3)
            myAjax({
                url: 'api/shopify/vehicle/options',
                data: {
                    key:'trim',
                    year: opts.year,
                    make: opts.make,
                    model: opts.model
                }
            }).then(data => {
                console.log('trim-data:', data)
                if(Array.isArray(data.data)){
                    t.trimList = [{value:'0', label:'Select Trim'}, ...data.data.map(item => ({value: item, label: item}))]
                }
                t.renderTrimData();
                !isNotShowLoading && t.hideSelectLoading(3)
                typeof callback === 'function' && callback()
            })
        }

      

        handlerEvent(){
            var t= this;
            //点击空白处关闭弹窗
            jQuery(document).on('click', function (event) {
                if(!jQuery(event.target).closest('.SelectForShopByVehicleName-drop-list').length && !jQuery(event.target).closest('.header-remember-search-box').length && !jQuery(event.target).closest('.SelectForShopByVehicleNameForMobile').length){
                    t.close();
                }
            })

            jQuery('select[name="select-for-shop-by-vehicle-select-year"]').on('change', function (){
                t.getMakeAjaxData({year: jQuery('select[name="select-for-shop-by-vehicle-select-year"]').val()}, () => {
                    t.modelList = [];
                    t.renderModelData();
                    t.trimList = [];
                    t.renderTrimData();
                   
                    jQuery('.select-for-shop-by-vehicle-search').attr("disabled", true);
                });
            })
            jQuery('select[name="select-for-shop-by-vehicle-select-make"]').on('change', function (){
                t.getModelAjaxData({year:jQuery('select[name="select-for-shop-by-vehicle-select-year"]').val(), make: jQuery('select[name="select-for-shop-by-vehicle-select-make"]').val()}, () => {
                    t.trimList = [];
                    t.renderTrimData();
                  
                    jQuery('.select-for-shop-by-vehicle-search').attr("disabled", true);
                })
            })
            jQuery('select[name="select-for-shop-by-vehicle-select-model"]').on('change', function (){
                t.getTrimAjaxData({year:jQuery('select[name="select-for-shop-by-vehicle-select-year"]').val(), make: jQuery('select[name="select-for-shop-by-vehicle-select-make"]').val(),model: jQuery('select[name="select-for-shop-by-vehicle-select-model"]').val()}, () => {
                   
                    jQuery('.select-for-shop-by-vehicle-search').attr("disabled", false);
                });
            })
            jQuery('select[name="select-for-shop-by-vehicle-select-trim"]').on('change', function (){
                if(jQuery(this).val() !== '0'){
                    jQuery('.select-for-shop-by-vehicle-search').attr("disabled", false);
                }
            })
        }

        handlerSubmitEvent(){
            var t = this;
            jQuery('.select-for-shop-by-vehicle-search').on('click', function (){
                var url = '';
                var lastId = '';
                var joinStr = '~'; //每个下拉框之间的连接符
                var selectJoinStr = '-'; //下拉框内参数连接符
                var $yearSelector = jQuery('select[name="select-for-shop-by-vehicle-select-year"]');
                if($yearSelector.val()){
                    var val = $yearSelector.val();
                    if(val != '0'){
                        t.setCache({year: $yearSelector.val()})
                        url += 'yr_' + $yearSelector.children('option:selected').text()
                        lastId = val;
                    }
                }

                var $makeSelector = jQuery('select[name="select-for-shop-by-vehicle-select-make"]');
                if($makeSelector.val()){
                    var val = $makeSelector.val();
                    if(val != '0'){
                        t.setCache({make: $makeSelector.val()})
                        url += joinStr + 'mk_' + $makeSelector.children('option:selected').text().replace(/\s|\./g, selectJoinStr)
                        lastId = val;
                    }

                }

                var $modelSelector = jQuery('select[name="select-for-shop-by-vehicle-select-model"]');
                if($modelSelector.val()){
                    var val = $modelSelector.val();
                    if(val != '0'){
                        t.setCache({model: $modelSelector.val()})
                        url += joinStr + 'md_' + $modelSelector.children('option:selected').text().replace(/\s|\./g, selectJoinStr)
                        lastId = val;
                    }

                }

                var $trimSelector = jQuery('select[name="select-for-shop-by-vehicle-select-trim"]');
                if($trimSelector.val()){
                    var val = $trimSelector.val();
                    if(val != '0'){
                        t.setCache({trim: $trimSelector.val()})
                        url += joinStr + 'kj_' + $trimSelector.children('option:selected').text().replace(/\s|\./g, selectJoinStr)
                        lastId = val;
                    }

                }

                 // 共有两个地方使用一样的代码
                var carLoadingEle = document.createElement('div');
                carLoadingEle.innerHTML = `
                  <div class="car-loading">
                    <img src="https://www.yitamotor.com/cdn/shop/t/70/assets/car-loading.gif" class="car-loading-img" alt="">
                  </div>
                `
                document.body.append(carLoadingEle)
              
                location.href = '/pages/product-result?rq=' + url.toLowerCase();
            });

            jQuery('.select-for-shop-by-vehicle-reset').on('click', function (){
                jQuery("#select-your-vehicle-year").val('0');
                jQuery("#select-your-vehicle-make").val('0');
                jQuery("#select-your-vehicle-model").val('0');
                jQuery("#select-your-vehicle-trim").val('0');

                t.modelList = [];
                t.renderModelData();
                t.trimList = [];
                t.renderTrimData();
            
                localStorage.removeItem('SelectForShopByVehicleCache');//清除记忆
                jQuery('.select-for-shop-by-vehicle-search').attr('disabled', true);
            });
        }

        getCache(key){
            var selectionCacheStr = localStorage.getItem('SelectForShopByVehicleCache');
            var selectionCache = {};
            if(/^{.*}$/.test(selectionCacheStr)){
                selectionCache = JSON.parse(selectionCacheStr);
            }
            return selectionCache[key] && selectionCache[key] != '0'? selectionCache[key]: ''
        }

        setCache(options){
            var selectionCacheStr = localStorage.getItem('SelectForShopByVehicleCache');
            var selectionCache = {};
            if(/^{.*}$/.test(selectionCacheStr)){
                selectionCache = JSON.parse(selectionCacheStr);
            }
            if(options.year){
                selectionCache.year = options.year;
            }
            if(options.make){
                selectionCache.make = options.make;
            }
            if(options.model){
                selectionCache.model = options.model;
            }
            if(options.trim){
                selectionCache.trim = options.trim;
            }
            localStorage.setItem('SelectForShopByVehicleCache', JSON.stringify(selectionCache));
        }

        isShow(){
            return jQuery('.SelectForShopByVehicleName-drop-list').length && !jQuery('.SelectForShopByVehicleName-drop-list').is(':hidden')
        }

        handlerCloseClick(){
            var t = this;
            jQuery('.select-for-shop-by-vehicle-close').on('click', function (){
                t.close();
            })
        }

        close(){
            jQuery('.SelectForShopByVehicleName-drop-list').hide()
        }

        destory(){
            jQuery('.SelectForShopByVehicleName-drop-list').remove()
        }

        showLoading(){
            if(document.querySelector('.component-full-loading')){
                return;
            }
            var ele = document.createElement('div');
            ele.className = 'component-full-loading';
            ele.innerHTML = `
            <div class="loading-wrapper" style="position: fixed;top: 0;left: 0;width: 100%;height: 100%;background: #0000004f;z-index:999999999;">
                 <div class="inner-loading" style="background: #494949;border: 1px solid #ccc; color: #fff; text-align: center; position: absolute;left:50%; top:50%; transform: translate(-50%, -50%);line-height: 38px;width: 150px;border-radius: 5px;">
                    <img style="vertical-align: middle;margin-right: 10px;" src="data:image/gif;base64,R0lGODlhEAAQALMMAKqooJGOhp2bk7e1rZ2bkre1rJCPhqqon8PBudDOxXd1bISCef///wAAAAAAAAAAACH/C05FVFNDQVBFMi4wAwEAAAAh+QQFAAAMACwAAAAAEAAQAAAET5DJyYyhmAZ7sxQEs1nMsmACGJKmSaVEOLXnK1PuBADepCiMg/DQ+/2GRI8RKOxJfpTCIJNIYArS6aRajWYZCASDa41Ow+Fx2YMWOyfpTAQAIfkEBQAADAAsAAAAABAAEAAABE6QyckEoZgKe7MEQMUxhoEd6FFdQWlOqTq15SlT9VQM3rQsjMKO5/n9hANixgjc9SQ/CgKRUSgw0ynFapVmGYkEg3v1gsPibg8tfk7CnggAIfkEBQAADAAsAAAAABAAEAAABE2QycnOoZjaA/IsRWV1goCBoMiUJTW8A0XMBPZmM4Ug3hQEjN2uZygahDyP0RBMEpmTRCKzWGCkUkq1SsFOFQrG1tr9gsPc3jnco4A9EQAh+QQFAAAMACwAAAAAEAAQAAAETpDJyUqhmFqbJ0LMIA7McWDfF5LmAVApOLUvLFMmlSTdJAiM3a73+wl5HYKSEET2lBSFIhMIYKRSimFriGIZiwWD2/WCw+Jt7xxeU9qZCAAh+QQFAAAMACwAAAAAEAAQAAAETZDJyRCimFqbZ0rVxgwF9n3hSJbeSQ2rCWIkpSjddBzMfee7nQ/XCfJ+OQYAQFksMgQBxumkEKLSCfVpMDCugqyW2w18xZmuwZycdDsRACH5BAUAAAwALAAAAAAQABAAAARNkMnJUqKYWpunUtXGIAj2feFIlt5JrWybkdSydNNQMLaND7pC79YBFnY+HENHMRgyhwPGaQhQotGm00oQMLBSLYPQ9QIASrLAq5x0OxEAIfkEBQAADAAsAAAAABAAEAAABE2QycmUopham+da1cYkCfZ94UiW3kmtbJuRlGF0E4Iwto3rut6tA9wFAjiJjkIgZAYDTLNJgUIpgqyAcTgwCuACJssAdL3gpLmbpLAzEQA7" alt="loading">
                    <span style="vertical-align: middle;">loading...</span>
                </div>
            </div>
        `
            document.body.appendChild(ele);
        }

        hideLoading (){
            var ele = document.querySelector('.component-full-loading')
            ele && document.body.removeChild(ele);
        }

        showSelectLoading(nth){
            var ymm = document.querySelector('.search-drop-list-select-list');
            var li = ymm?.querySelectorAll('li')[nth];
            if(li){
                li.classList.add('is-loading-select')
            }
        }
        hideSelectLoading(nth){
            var ymm = document.querySelector('.search-drop-list-select-list');
            var li = ymm?.querySelectorAll('li')[nth];
            if(li){
                li.classList.remove('is-loading-select')
            }
        }

    }


    $('.SelectForShopByVehicleNameForMobile, .SelectForShopByVehicleIcon').on('click', function (){
        new SelectForShopByVehicle({target: $(this)});
    });


});
